module.exports = __webpack_public_path__ + "14four/static/media/Logo.f16e2370.png";